import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Table } from 'components'
import { WrapDataGrid, Header } from 'components/DataGrid/Style'
import { userHooks } from '.'
import { UsersContext } from './UsersContext'
import { LightButton, TablePageStyles, WrapHeader } from 'styles/GlobalStyle'
import { Can } from 'components/Permissions'
import { dataGridModel } from 'keys'
import { Title as ScreenTitle } from 'components'
import { UsersStyles } from './Style'
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader'

const Users = (props) => {
    const { user, users, usersOptions, onCollapse, rowOpen, setRowOpen, searchVal, setSearchVal, sorting, setSorting, pageSize, setPageSize, page, setPage, userRoleOptions } = useContext(UsersContext)
    const { usersColumns, userColumns } = userHooks.useColumns()

    const headerBtns = userHooks.useHeaderBtns()
    const headerFilters = userHooks.useHeaderFilters()

    const refetchData = useCallback(() => {
        users.refetch()
    }, [])

    return (
        <UsersStyles>
            <ScreenTitle {...props} height={38} breadcrumbs={true}>
                <div className='bread-crumbs-title'>
                    <Can I="manage" a="super-user">
                        {headerBtns.map((headerBtn, index) =>
                            <LightButton
                                variant="solid"
                                key={index}
                                {...headerBtn}
                            />
                        )}
                    </Can>
                </div>
            </ScreenTitle>
            <TablePageStyles>
                <Table
                    withTitle
                    rowOpen={rowOpen}
                    setRowOpen={setRowOpen}
                    loading={users.isFetching && !users.data}
                    data={users.data || { results: [] }}
                    page={page}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    columns={usersColumns}
                    setPage={setPage}
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    sorting={sorting}
                    setSorting={setSorting}
                    queryKey={usersOptions.queryKey}
                    visibilityModelKey={dataGridModel.users}
                    collapse={{
                        show: true,
                        columns: userColumns,
                        showToolbar: true,
                        data: user.data || { results: [] },
                        blurred: ({ original }) => original.assessment_hidden,
                        onCollapse: onCollapse,
                        showChollapseIcon: true,
                    }}
                />
            </TablePageStyles>
        </UsersStyles>
    )
}

export default Users
